import DigitalMarketingOffers from "./DigitalMarketingOffers";

const DigitalMarketing = () => {
  return (
    <section className="solution-item-page">
      <DigitalMarketingOffers />
    </section>
  );
};

export default DigitalMarketing;
